import { createActionTypes } from "@helpers/redux-helpers";

export const getUserBlockListActionTypes = createActionTypes("get/blockList");

export const deleteUserFromBlockListActionTypes = createActionTypes(
  "unblockUser/blockList",
);
